// 幾つかのモジュールをグローバル空間に置いています
// いつかなくしたいです
import PubSub from 'pubsub-js'

window.PubSub = PubSub
